import { LinkReturnToMain } from 'Components';
import { Title } from './Title';
import { Categories } from './Categories';

export const Lobby = () => {
  return (
    <>
      <LinkReturnToMain link={process.env.REACT_APP_MARKETING_SITE_URL} />
      <Title />
      <Categories />
    </>
  );
};
